import { currentUserAtom } from "@/store/login";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";

export const Route = createFileRoute("/")({
	beforeLoad: async () => {
		const user = getDefaultStore().get(currentUserAtom);

		if (user?.user_role === "ADMIN") {
			throw redirect({ to: "/st-admin/dashboard" });
		}

		throw redirect({ to: "/dashboard" });
	},
});
